"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bedizzole": {
    "df816bc4": [{
      "hkey": "b52cb469",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "b52cb469",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3ca3d8ae": [{
      "hkey": "273f8d4b",
      "slug": "san-vito-campagnola",
      "name": "San Vito-Campagnola",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito": [{
      "hkey": "273f8d4b",
      "slug": "san-vito-campagnola",
      "name": "San Vito-Campagnola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;